// AI Generated Component
import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
    selector: 'form-field-errors',
    templateUrl: './form-field-errors.component.html',
    standalone: false,
})
export class FormFieldErrorsComponent {
    @Input() input: any; // Can be AngularJS form field or Angular AbstractControl
    @Input() patternMsg?: string;
    @Input() offset?: string = '8';

    checkForErrors (): boolean {
        if (!this.input) {
            return false;
        }

        // Check if it's an Angular reactive form control
        if (this.isAngularFormControl(this.input)) {
            // console.log(this.input.dirty, this.input.touched);
            return this.input.invalid && (this.input.touched);
        }

        // Check if it's an AngularJS form field
        if (this.isAngularJSFormField(this.input)) {
            let result = false;
            if (this.input.$error) {
                for (const i of Object.keys(this.input.$error)) {
                    if (this.input.$error[i]) {
                        result = true;
                        break;
                    }
                }
            }
            return result && this.input.$dirty;
        }

        return false;
    }

    hasError (errorType: string): boolean {
        if (!this.input) {
            return false;
        }

        // Angular reactive form control
        if (this.isAngularFormControl(this.input)) {
            return !!(this.input.errors && this.input.errors[errorType]);
        }

        // AngularJS form field
        if (this.isAngularJSFormField(this.input)) {
            return !!(this.input.$error && this.input.$error[errorType]);
        }

        return false;
    }

    gridSize (offset: string = '0'): number {
        return 48 - parseInt(offset, 10);
    }

    private isAngularFormControl (input: any): input is AbstractControl {
        return input && typeof input.hasError === 'function' &&
               input.errors !== undefined &&
               input.invalid !== undefined &&
               input.dirty !== undefined &&
               input.touched !== undefined;
    }

    private isAngularJSFormField (input: any): boolean {
        return input &&
               input.$error !== undefined &&
               input.$dirty !== undefined &&
               input.$invalid !== undefined;
    }
}
